export default __webpack_public_path__ + "static/media/softSagesMedicalTemplate.56e95e22.png";